
export const toMoneyFormat = (sum) => {
    //const coeff = 1.1;

    //sum = Math.ceil(sum * coeff);
    if (!sum) {
        return '0\u00a0'
    }
    
    sum = sum.toString().trim()
    let arr = []
    const n = 3
    const len = sum.length
    
    if (len > 3) {
        for (let i = len; i > -n; i -= n) {
            if (i > 0) {
                arr.unshift(sum.substr(i, n))
            } else {
                arr.unshift(sum.substr(0, (n + i)))
            }
        }
        
        return arr.join('\u00a0') // &nbsp;
    } else {
        return sum+'\u00a0' // &nbsp;
    }
}



// WEBPACK FOOTER //
// ./tools/number.js